const tables = [
  {
    name: "PO Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due Date",
  },
  {
    name: "Total Amount",
  },
  {
    name: "Paid Amount",
  },
  {
    name: "Outstanding",
  },
  {
    name: "Payment Status",
  },
  {
    name: "Delivery Status",
  },
];

export default tables;